import Script from 'next/script';

export const YANDEX_METRICA_ID = 89370833;

export default function YandexMetrica() {
  return (
    <>
      <Script
        strategy="afterInteractive"
        id={'ya-metrica'}
        dangerouslySetInnerHTML={{
          __html: `(function (m, e, t, r, i, k, a) {
    m[i] =
      m[i] ||
      function () {
        (m[i].a = m[i].a || []).push(arguments);
      };
    m[i].l = 1 * new Date();
    (k = e.createElement(t)),
      (a = e.getElementsByTagName(t)[0]),
      (k.async = 1),
      (k.src = r),
      a.parentNode.insertBefore(k, a);
  })(window, document, 'script', 'https://mc.yandex.ru/metrika/tag.js', 'ym');
  ym(${YANDEX_METRICA_ID}, 'init', {
    clickmap: true,
    trackLinks: true,
    accurateTrackBounce: true,
  });`,
        }}
      />
      <noscript>
        <div>
          <img
            src={`https://mc.yandex.ru/watch/${YANDEX_METRICA_ID}`}
            style={{position: 'absolute', left: '-9999px'}}
            alt=""
          />
        </div>
      </noscript>
    </>
  );
}
